export default "__VITE_ASSET__DRbQCZqh__"